module.exports = __webpack_public_path__ + "logo-shopware5.1a40a59b49836455a33d21ff0ddd5d79.svg";